<template>
  <point-chart
    :datasets="chartData"
    :configuration="configuration"
    :x-axis-size="xAxisSize"
    :y-axis-size="yAxisSize"
    :x-axis-label="
      $t('components.graphs.ship.logistics.x_axis_label', { n: 1000 })
    "
    :y-axis-label="
      $t('components.graphs.ship.logistics.y_axis_label', { n: 1000 })
    "
    ><template v-slot:title>{{
      $t("components.graphs.ship.logistics.title")
    }}</template></point-chart
  >
</template>

<script>
import PointChart from "@/components/charts/PointChart";
import { ShipEvaluator } from "@/services/ShipEvaluator";
export default {
  name: "ShipGraphLogistics",
  components: { PointChart },
  props: {
    shipTypes: {
      type: Array
    }
  },
  data: () => {
    return {
      configuration: {
        xAxisResolution: 10000,
        yAxisResolution: 2500
      }
    };
  },
  computed: {
    chartData() {
      return this.shipTypes
        .filter(t => t != null && t.cost.length > 0 && t.capacity > 0)
        .map(t => {
          return {
            name: t.name,
            image: t.image,
            x: ShipEvaluator.getSpeedRating(t),
            y: ShipEvaluator.getCapacityRating(t)
          };
        });
    },
    xAxisSize() {
      return this.chartData.length > 0
        ? Math.max(...this.chartData.map(d => d.x))
        : 1;
    },
    yAxisSize() {
      return this.chartData.length > 0
        ? Math.max(...this.chartData.map(d => d.y))
        : 1;
    }
  }
};
</script>

<style scoped></style>
